const Promise = require('bluebird');
const Reflux = require('@muzzylane/reflux');

const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const ServerRequest = require('./request');
const ActivityWebSocket = require('../util/activityWebSocket');

const WebSocketActions = Reflux.createActions({
    getActivityLock: { children: ['completed', 'failed'] },
    releaseActivityLock: { children: ['completed', 'failed'] },
    reestablishActivityLock: { children: ['completed', 'failed'] },
    refreshActivityLock: { children: ['completed', 'failed'] },
    updateActivityVersion: { children: ['completed', 'failed'] },
    clearForceUnlockState: { children: ['completed', 'failed'] },
    resetStore: { children: ['completed'] },
    ensureLockReleased: { children: [] },
    devTestWSDisconnect: { children: ['completed'] },
});

WebSocketActions.getActivityLock.listen(function(actionId, params) {
    if (
        !params.userId
        || !params.product
        || !params.moduleId
        || !params.moduleVersion
        || !params.activityId
        || !params.activityVersion
    ) {
        this.failed(actionId, null, params.activityId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    const actWebSocket = new ActivityWebSocket(params);
    actWebSocket.connectAuthLock()
        .then(res => this.completed(actionId, actWebSocket))
        .catch(err =>  this.failed(actionId, actWebSocket, params.activityId, err));
});

WebSocketActions.releaseActivityLock.listen(function(actionId, params) {
    if (!params.actWebSocket) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    params.actWebSocket.releaseLock()
        .then(res => this.completed(actionId, params.actWebSocket.activityId))
        .catch(err => this.failed(actionId, err));
});

WebSocketActions.refreshActivityLock.listen(function(actionId, params) {
    if (!params.actWebSocket) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    params.actWebSocket.refreshLock()
        .then(res => this.completed(actionId, params.actWebSocket))
        .catch(err => this.failed(actionId, err));
});

WebSocketActions.reestablishActivityLock.listen(function(actionId, params) {
    if (!params.actWebSocket) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    params.actWebSocket.connectAuthLock(true)
        .then(res =>  this.completed(actionId, params.actWebSocket))
        .catch(err => this.failed(actionId, params.activityId, err));
    });

WebSocketActions.updateActivityVersion.listen(function(actionId, params) {
    if (!params.version) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    this.completed(actionId, params.version);
});

WebSocketActions.clearForceUnlockState.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activity/${params.id}/force_unlock`, 'DELETE', JSON.stringify(params))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, err));
});

WebSocketActions.resetStore.listen(function(actionId, params) {
    this.completed(actionId, params.lockProcessBegun);
});

WebSocketActions.ensureLockReleased.listen(function(actionId, params) {
    if (
        !!params
        && !!params.actWebSocket
        && !!params.actWebSocket._haveLock
        && !params.connectionLost
    ) {
        WebSocketActions.releaseActivityLock(actionId, params);
    }
    else {
        WebSocketActions.resetStore(actionId, params);
    }
});

if (GlobalConfig.DevMode) {
    WebSocketActions.devTestWSDisconnect.listen(function() { this.completed() })
}
else {
    WebSocketActions.devTestWSDisconnect.listen(() => { return })
}

module.exports = WebSocketActions;